import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { actionTypes } from '../reducer';

function* createPhone() {
  yield requestSaga({
    actionType: actionTypes.create,
    request: dataProvider.createOne,
    resource: resources.simCard.index,
  });
}

export default createPhone;
